import { get } from 'lodash';

export default function (object: any) {
  const formattedObj = { "_id": get(object, 'id'), ...get(object, 'attributes', {})};
  return formattedObj;
}